import DevelopersPage from "../../../component/users/developers/DevelopersPage"

 
 
function Developers() {
  return (
    <div className="page-body"><DevelopersPage/></div>
  )
}

export default Developers